import React, { Component } from "react"
import { connect } from "react-redux"

// components
import Navbar from "../../components/layout/DashboardNavbar"
import MainSection from "../../components/layout/MainSection"
import ScrollableContentCard, { Padding } from "../../components/layout/ScrollableContentCard"
import Footer from "../../components/Footer"

// mui
import Typography from "@mui/material/Typography"
import Box from "@mui/material/Box"
import Divider from "@mui/material/Divider"
import { withStyles } from "@mui/styles"

const styles = () => ({
  root: {
  },
  title: {
    fontFamily: "comfortaa",
    fontSize: "22px",
    fontWeight: "bold",
    marginTop: "15px",
    marginBottom: "15px",
  },
  heading: {
    fontSize: "18px",
    fontWeight: "bold",
    marginTop: "10px",
    marginBottom: "15px",
  },
  paragraph: {
    fontSize: "16px",
    marginBottom: "15px",
  }
})

class HowToBookmark extends Component {
  render() {
    const { classes, portrait, urlSource } = this.props

    return (
      <React.Fragment>
        <Navbar
          title="Bookmarks"
          backLink
          portrait={portrait}
        />

        <MainSection portrait={true}>
          <ScrollableContentCard limitedWidth>
            <Padding>
              <Typography component="div">
                <Box className={classes.title}>
                  How to Add a Bookmark for the Numerable app
                </Box>
                <Box className={classes.paragraph}>
                  It's easy to bookmark Numerable {/*or add an icon on your mobile's home screen, */}so you can quickly find it when you need it.
                </Box>

                <Box className={classes.heading}>
                  Android phone or tablet – Chrome:
                </Box>
                <Box className={classes.paragraph}>
                  Launch Chrome and go to app.numerable.io.
                </Box>
                <Box className={classes.paragraph}>
                  Tap the <strong>3 dots menu icon</strong> and then {/*either */}scroll the menu and {/*tap "<strong>Add to Home screen</strong>", to use Numerable just like a normal app – or*/} tap the <strong>star</strong> icon to add a bookmark.
                </Box>

                <Divider />
                <Box className={classes.heading}>
                  iPhone or iPad – Safari:
                </Box>
                <Box className={classes.paragraph}>
                  Launch Safari and go to app.numerable.io.
                </Box>
                <Box className={classes.paragraph}>
                  Tap the <strong>Share icon</strong> on the browser's toolbar — that’s the blue rectangle with an arrow pointing upward, at the bottom of the screen on an iPhone, or top on an iPad.
                </Box>
                <Box className={classes.paragraph}>
                  Scroll the menu and {/*either */}tap: {/*"<strong>Add to Home Screen</strong>" then tap "<strong>Add</strong>", so you can get to Numerable from an icon, just like a native app – or */}"<strong>Add Bookmark</strong>", then choose where to save the bookmark.
                </Box>

                <Divider />
                <Box className={classes.heading}>
                  iPhone or iPad – Chrome:
                </Box>
                <Box className={classes.paragraph}>
                  Launch Chrome and go to app.numerable.io
                </Box>
                <Box className={classes.paragraph}>
                  Tap the <strong>Share icon</strong> on the browser's address bar — that's the grey rectangle with an arrow pointing upward.
                </Box>
                <Box className={classes.paragraph}>
                  Scroll the menu and tap "<strong>Bookmark</strong>".
                </Box>

              </Typography>

            </Padding>
          </ScrollableContentCard>
        </MainSection >

        <Footer urlSource={urlSource} />
      </React.Fragment>
    )
  }
}

const mapStateToProps = ({ common, user }) => {
  return {
    portrait: user.portrait,
    urlSource: common.urlSource,
  }
}

export default connect(mapStateToProps)(withStyles(styles)(HowToBookmark))

